module.exports = __webpack_public_path__ + "img/aboutUs.c1f2d6db.jpg";